import { Settings } from '@mui/icons-material'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { changes } from 'src/components/utils/fields'
import { LoadingContext, M_Button, M_Fieldset } from 'src/M_Components'
import { QuoteFormField } from './QuoteFormField'

export const QuoteChargesSettings = ({
  multipleOptions,
  dataState,
  setDataState,
  passedRowState,
  setPassedRowState,
  onClose,
}) => {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()

  const payableHowOptions = [
    { label: t('Prepaid'), value: 'P' },
    { label: t('Collect'), value: 'C' },
    { label: t('Prep. Else'), value: 'Q' },
    { label: t('Coll. Else'), value: 'D' },
    { label: t('Other'), value: 'O' },
    { label: t('BLANK'), value: '' },
  ]

  const payingCompanyOptions = [
    { label: t('Client'), value: 'C' },
    { label: t('Other - Foreign Currency'), value: 'E' },
    { label: t('Invoice'), value: 'I' },
    { label: t('Shipper'), value: 'S' },
    { label: t('Consignee'), value: 'G' },
    { label: t('Notify'), value: 'N' },
    { label: t('Agent'), value: 'A' },
    { label: t('Feeder'), value: 'F' },
    { label: t('Other'), value: 'O' },
  ]

  const formDetailFields = [
    {
      display: t('LumpSum'),
      required: false,
      code: 'lumpSumCode',
      type: 'foreignKey',
      entity: 'LumpSum',
      filterField: 'code',
      labelFields: ['Code'],
      fields: [
        { key: 'Code', value: 'lumpSumCode' },
        { key: 'Name', value: 'lumpSumName' },
        { key: 'Id', value: 'lumpSumId' },
      ],
      favoritesFieldName: t('LumpSum'),
      favoritesGroupName: 'Charges',
      favoritesVarKey: 'lumpSumCode',
      favoritesIdKey: 'lumpSumId',
    },
    {
      display: t('PayableHow'),
      required: false,
      code: 'payableHow',
      type: 'select',
      options: payableHowOptions,
      extraField: 'payableHowValue',
      favoritesFieldName: t('PayableHow'),
      favoritesGroupName: 'Charges',
      favoritesVarKey: 'payableHow',
    },
    {
      display: t('PayingCompany'),
      required: false,
      code: 'payingCompany',
      type: 'select',
      options: payingCompanyOptions,
      extraField: 'payingCompanyValue',
      favoritesFieldName: t('PayingCompany'),
      favoritesGroupName: 'Charges',
      favoritesVarKey: 'payingCompany',
    },
  ]

  const formRestrictionFields = [
    {
      display: t('EquipmentType'),
      required: false,
      code: 'restrictionsEquipmentType',
      type: 'foreignKey',
      entity: 'equipmentType',
      filterField: 'EquipmentTypeCode',
      labelFields: ['EquipmentTypeLenght', 'EquipmentTypeCode'],
      fields: [
        { key: 'EquipmentTypeLenght', value: 'restrictionsSize' },
        { key: 'EquipmentTypeCode', value: 'restrictionsEquipmentType' },
        { key: 'Id', value: 'restrictionsEquipmentTypeId' },
      ],
      favoritesFieldName: t('EquipmentType'),
      favoritesGroupName: 'Charges',
      favoritesVarKey: 'restrictionsEquipmentType',
      favoritesIdKey: 'restrictionsEquipmentTypeId',
    },
  ]

  const formManifestFields = [
    {
      display: t('Value'),
      required: false,
      code: 'manifestValue',
      type: 'number',
    },
    {
      display: t('Multiple'),
      required: false,
      code: 'manifestMultiple',
      type: 'select',
      options: multipleOptions,
      extraField: 'manifestMultipleValue',
      favoritesFieldName: t('ManifestMultiple'),
      favoritesGroupName: 'Charges',
      favoritesVarKey: 'manifestMultiple',
    },
    {
      display: t('ManifestCurrency'),
      required: false,
      code: 'manifestCurrencyCode',
      type: 'foreignKey',
      entity: 'Currency',
      filterField: 'code',
      labelFields: ['Code'],
      fields: [
        { key: 'Code', value: 'manifestCurrencyCode' },
        { key: 'Id', value: 'manifestCurrencyId' },
      ],
      favoritesFieldName: t('ManifestCurrency'),
      favoritesGroupName: 'Charges',
      favoritesVarKey: 'manifestCurrencyCode',
      favoritesIdKey: 'manifestCurrencyId',
    },
  ]

  const saveSettings = () => {
    const oldArray = dataState['charges']
    const newArray = oldArray.map((old) => {
      if (old.id === passedRowState.id) {
        return passedRowState
      }
      return old
    })
    changes('charges', newArray, setDataState)
    setPassedRowState({})
    onClose()
  }

  return (
    <>
      <div style={{ margin: '0px 5px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: '10px 0px',
          }}
        >
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <h2
              style={{
                color: ctx.secondaryColor,
                display: 'flex',
                alignItems: 'center',
                marginTop: '0px',
              }}
            >
              <Settings style={{ marginRight: '5px', fontSize: '30px' }} />
              {t('QuoteSettings')}
            </h2>
          </span>
          <div
            style={{
              border: `1px solid ${ctx.primaryColor}`,
              width: '90%',
            }}
          ></div>
        </div>
        <div style={{ margin: '50px' }}></div>
        <M_Fieldset
          labelInside
          label={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '25px',
                marginLeft: '10px',
              }}
            >
              {' '}
              {t('Restricions')}
            </div>
          }
          elements={
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'auto auto ',
                justifyContent: 'space-evenly',
              }}
            >
              {formRestrictionFields.map((field, index) => (
                <QuoteFormField key={index} fields={field} index={index} data={passedRowState} setData={setPassedRowState} />
              ))}
              <div style={{ minWidth: '260px' }} />
            </div>
          }
        />
        <div style={{ margin: '50px' }}></div>
        <M_Fieldset
          labelInside
          label={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '25px',
                marginLeft: '10px',
              }}
            >
              {' '}
              {t('Manifest')}
            </div>
          }
          elements={
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'auto auto ',
                justifyContent: 'space-evenly',
              }}
            >
              {formManifestFields.map((field, index) => (
                <QuoteFormField key={index} fields={field} index={index} data={passedRowState} setData={setPassedRowState} options={field?.options} />
              ))}
            </div>
          }
        />
        <div style={{ margin: '50px' }}></div>
        <M_Fieldset
          labelInside
          label={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '25px',
                marginLeft: '10px',
              }}
            >
              {' '}
              {t('Details')}
            </div>
          }
          elements={
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'auto auto ',
                justifyContent: 'space-evenly',
              }}
            >
              {formDetailFields.map((field, index) => (
                <QuoteFormField key={index} fields={field} index={index} data={passedRowState} setData={setPassedRowState} options={field?.options} />
              ))}
            </div>
          }
        />
        <div style={{ margin: '50px' }}></div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginRight: '10px',
            marginLeft: '10px',
          }}
        >
          <div></div>
          <div style={{ display: 'flex' }}>
            <M_Button
              hoverEffect
              width={20}
              label={t('Save')}
              onClick={() => saveSettings()}
              backgroundColor={'var(--color-green)'}
              labelColor={'var(--color-white)'}
            />
            <M_Button
              hoverEffect
              width={15}
              label={t('Cancel')}
              onClick={onClose}
              backgroundColor={'var(--color-red)'}
              labelColor={'var(--color-white)'}
            />
          </div>
        </div>
      </div>
    </>
  )
}
